import React, { useContext, useEffect, useState } from "react";
import { useCallback } from "react";
import PropTypes from "prop-types";

import { useHttp } from "../hooks/http.hook";
import { AuthContext } from "../context/AuthContext";
import { useSelector, useDispatch } from "react-redux";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CardContent from "@mui/material/CardContent";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useTranslate } from "../lib/translate/i18n/useTranslate";
import { default as Spinner } from "../components/Spinner";
import Typography from "@mui/material/Typography";
import GridTable from "../lib/react-grid-table/index";

import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";

import FormControl from "@mui/material/FormControl";
//import InputLabel from "@mui/material/InputLabel";
//import OutlinedInput from "@mui/material/OutlinedInput";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

import {
  Avatar,
  Card,
  CardActions,
  CircularProgress,
  Divider,
} from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LockIcon from "@mui/icons-material/Lock";
import { Form } from "react-bootstrap";
import TextField from "@mui/material/TextField";

import { useLocation, useParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { getURLAPI } from "../utils/getURL";
import { Client as WebSocket } from "rpc-websockets";
import Box from "@mui/material/Box";

import QRCode from "react-qr-code";
import $ from "jquery";
//import NiceModal, { useModal } from "@ebay/nice-modal-react";
//import Slide from '@material-ui/core/Slide';
//import { TransitionProps } from '@material-ui/core/transitions';

//import { REFUSED } from 'dns'
//import { pdfjs, Document, Page } from "react-pdf";
//import "react-pdf/dist/Page/AnnotationLayer.css";
//import "react-pdf/dist/Page/TextLayer.css";

//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

//pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//  "pdfjs-dist/build/pdf.worker.min.mjs",
//  import.meta.url
// ).toString();

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

let customer = null;
let storetypes = null;
//let documents = null;
var columns2 = [];
var rows = [];
var setaddr = {};
var setdoc = {};
var columns3 = [];
var docs = [];
let StartMinutes = 3;
let StartSeconds = 0;

let Minutes;
let Seconds;
$("#Minutes").html(String(Minutes).padStart(2, "0"));
$("#Seconds").html(String(Seconds).padStart(2, "0"));

const GetClient = (props) => {
  //console.log('Refresh !!!')
  //const [loading1, setLoading] = useState(
  const auth = useContext(AuthContext);
  //  customer = auth.Customer;

  //let pathname = window.location.href; //props.
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const param = useParams();

  const [changed1, setChanged1] = useState(false);
  const [changed2, setChanged2] = useState(false);
  const [changed3, setChanged3] = useState(false);

  //  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  //    "pdfjs-dist/build/pdf.worker.min.mjs",
  //    import.meta.url
  //  ).toString();
  const [tab, setTab] = useState("1");
  let location = useLocation();
  let pathname = location.pathname.split("/")[1];
  //const navigate = useNavigate();

  let reference = auth.Customer && auth.Customer.reference;
  if (reference && reference !== pathname) {
    //goto reference
    //navigate("/" + reference); // example
  }

  const config = auth.config;
  const translate = useTranslate();
  const dispatch = useDispatch();

  //ПОМЕНЯТЬ на UseEffect
  /*
  if (!customer) {
    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: { customer: auth.Customer, storetypes: auth.StoreTypes },
      ob: "infocustomer",
    });
  }
    */

  //08.07.25
  useEffect(() => {
    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: { customer: auth.Customer, storetypes: auth.StoreTypes },
      ob: "infocustomer",
    });
    console.log(location.pathname);
  }, [auth.Customer]); //auth.Customer, auth.StoreTypes]);

  const body = useSelector((state) => state.app.body);

  customer = body && body.infocustomer && body.infocustomer.customer;
  storetypes = body && body.infocustomer && body.infocustomer.storetypes;

  var types = [];

  for (var i in storetypes) {
    types.push({
      label: storetypes[i].name,
      value: storetypes[i].id,
    });
  }

  useEffect(() => {
    console.log(location.pathname);
  }, []);

  const {
    loading,
    request,
    error,
    clearError,
    getIpInfo,
    setLoading,
    setError,
  } = useHttp();
  const [form, setForm] = useState({
    login: "",
    password: "",
  });
  //const [ws_client, setWs_client] = useState(null)
  const [change, setChange] = useState(false);

  const [openAddressDialog, setOpenAddressDialog] = useState(false);
  const [openDocumentsDialog, setOpenDocumentsDialog] = useState(false);
  //let maxWidth = "65em";

  //if (!ws_client) {
  //ws_client = new WebSocket(URL_WS) //'ws://' + ws_host + ':' + ws_port)
  //  setWs_client(new WebSocket(URL_WS))
  // }

  const changeHandler = (event) => {
    let value = event.target.value;
    if (event.target.name === "login") value = value.toLowerCase();
    setForm({ ...form, [event.target.name]: value });
    setChange(true);
    clearError();
  };
  //async
  const wssrequest = useCallback(async (options = null, URL_WS = null) => {
    setLoading(true);

    try {
      //URL_WS = 'wss://shop.pegas-sk.com.ua:8043'

      let ws_client = new WebSocket(URL_WS);

      ws_client.on("close", function () {
        console.log("event : ws_client close !!!");
      });
      ws_client.on("error", (error) => {
        console.log("ws_client error", error);
      });

      ws_client.on("open", async function () {
        // login your client to be able to use protected methods
        ws_client
          .login(options)
          .then(function (result) {
            //console.log('read from table Users where login passw : ', result)
            /*
            if (result.status === 200) {
              auth.login(result.data.token, result.data.userId)
            } else if (result.status === 400) {
              //err
              console.log('ERR login : ', result)
              setError(result.message)
            }
*/

            //let options = { ...form }
            let tableName = "ChangeCustomers";
            let action = { metod: "reference" };
            //read from table UnitTypes, where  id=1
            ws_client
              .call("Model_read", { tableName, where: options, action })
              .then(function ({ tableName, result }) {
                //console.log('read from table Users where login passw : ',result)
                if (result.status === 200) {
                  auth.login(
                    result.data.token,
                    result.data.userId,
                    result.data.reference
                  );
                  auth.setCustomer(result.data.customer);
                  dispatch({
                    type: "fetch/get_add", //'fetch/get_add',
                    payload: result.data.customer,
                    ob: "customer",
                  });
                } else if (result.status === 400) {
                  //err
                  setError(result.message);
                }
              })
              .catch(function (error) {
                console.log("err", error);
                setError(error);
              });

            setLoading(false);
          })
          .catch(function (error) {
            console.log("auth failed - error : ", error);
            setLoading(false);
            setError(error);
          });
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setError(error);
    }
  });

  const wssrequestsave = useCallback(
    async (options = null, URL_WS = null, metod = "referencesave") => {
      setLoading(true);

      try {
        //URL_WS = 'wss://shop.pegas-sk.com.ua:8043'

        let ws_client = new WebSocket(URL_WS);

        ws_client.on("close", function () {
          console.log("event : ws_client close !!!");
        });
        ws_client.on("error", (error) => {
          console.log("ws_client error", error);
        });

        ws_client.on("open", async function () {
          // login your client to be able to use protected methods
          ws_client
            .login(options)
            .then(function (result) {
              //console.log('read from table Users where login passw : ', result)
              /*
            if (result.status === 200) {
              auth.login(result.data.token, result.data.userId)
            } else if (result.status === 400) {
              //err
              console.log('ERR login : ', result)
              setError(result.message)
            }
            */
              //let options = { ...form }
              let tableName = "ChangeCustomers";
              let action = { metod };
              //read from table UnitTypes, where  id=1
              ws_client
                .call("Model_read", { tableName, where: options, action })
                .then(function ({ tableName, result }) {
                  //console.log('read from table Users where login passw : ',result)
                  if (result.status === 200) {
                    auth.login(
                      result.data.token,
                      result.data.userId,
                      result.data.reference
                    );
                    auth.setCustomer(result.data.customer);
                    dispatch({
                      type: "fetch/get_add", //'fetch/get_add',
                      payload: result.data.customer,
                      ob: "customer",
                    });
                  } else if (result.status === 400) {
                    //err
                    setError(result.message);
                  }
                })
                .catch(function (error) {
                  console.log("err", error);
                  setError(error);
                });

              setLoading(false);
            })
            .catch(function (error) {
              console.log("auth failed - error : ", error);
              setLoading(false);
              setError(error);
            });
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
        setError(error);
      }
    }
  );

  const wssrequestget = useCallback(
    async (options = null, URL_WS = null, metod = "getdeeplink") => {
      setLoading(true);

      try {
        //URL_WS = 'wss://shop.pegas-sk.com.ua:8043'

        let ws_client = new WebSocket(URL_WS);

        let handle_GetData = options.handle_GetData;
        let handle_ErrData = options.handle_ErrData;
        let tableName = options.tableName;

        ws_client.on("close", function () {
          console.log("event : ws_client close !!!");
        });
        ws_client.on("error", (error) => {
          console.log("ws_client error", error);
        });

        ws_client.on("open", async function () {
          // login your client to be able to use protected methods
          ws_client
            .login(options)
            .then(function (result) {
              //console.log('read from table Users where login passw : ', result)
              /*
            if (result.status === 200) {
              auth.login(result.data.token, result.data.userId)
            } else if (result.status === 400) {
              //err
              console.log('ERR login : ', result)
              setError(result.message)
            }
            */
              //let options = { ...form }
              //let tableName = "ChangeCustomers";
              let action = { metod };
              //read from table UnitTypes, where  id=1
              ws_client
                .call("Model_read", { tableName, where: options, action })
                .then(function ({ tableName, result }) {
                  //console.log('read from table Users where login passw : ',result)
                  if (result.status === 200) {
                    console.log("result", result);

                    if (handle_GetData) {
                      handle_GetData(result, options);
                    }
                  } else {
                    if (handle_ErrData) {
                      handle_ErrData(result, options);
                    }
                  }

                  //if (result.status === 400) {
                  //err
                  //setError(result.message);
                  //}
                })
                .catch(function (error) {
                  console.log("err", error);
                  setError(error);
                });

              setLoading(false);
            })
            .catch(function (error) {
              console.log("auth failed - error : ", error);
              setLoading(false);
              setError(error);
            });
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
        setError(error);
      }
    }
  );

  const logoutinHandler = async () => {
    auth.setCustomer(null);
    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: null,
      ob: "customer",
    });

    auth.logout();
  };
  //

  const saveHandler = async () => {
    try {
      const config = auth.config;

      let reference =
        location.pathname.split("/")[1] || auth.Customer.reference;
      //      let URLAPI = getURLAPI(config)
      let Options = { reference, customer };
      //
      if (customer) customer.ischanged = true;

      let URL_WS = getURLAPI(config, "URL_WS"); //get address WebSocket BK from config

      const data1 = await wssrequestsave(Options, URL_WS, "referencesave");
    } catch (e) {
      console.log("errr e", e);
    }
  };

  const saveNewAddrHandler = async () => {
    try {
      const config = auth.config;

      let reference =
        location.pathname.split("/")[1] || auth.Customer.reference;
      //      let URLAPI = getURLAPI(config)
      let Options = { reference, customer, setaddr };
      //
      if (customer) customer.ischanged = true;

      let URL_WS = getURLAPI(config, "URL_WS"); //get address WebSocket BK from config

      const data1 = await wssrequestsave(Options, URL_WS, "addNewAddr");
    } catch (e) {
      console.log("errr e", e);
    }
  };

  const loadHandler = async () => {
    try {
      const config = auth.config;

      let reference = location.pathname.split("/")[1];
      //      let URLAPI = getURLAPI(config)
      let Options = { reference };
      //
      let URL_WS = getURLAPI(config, "URL_WS"); //get address WebSocket BK from config

      let options = { ...form };

      const { login, password } = options;

      let message;
      /*
      if (!login || login === "") {
        message = "Не задан login";
        setError(message);

        return;
      }

      if (!password || password === "") {
        message = "Не задан пароль";
        setError(message);

        return;
      }
*/

      //чтение
      const data1 = await wssrequest(Options, URL_WS);
      /*
      const data = await request(
        '/api/auth/login',
        'POST',
        { ...form },
        {},
        URLAPI
      )
*/
      /*
      const data = await request('/api/auth/login', 'POST', { ...form })
      auth.login(data.token, data.userId)
*/
      /*    const ipinfo = await getIpInfo('185.30.200.25')
      console.log('1', ipinfo)
      const ipinfo2 = await getIpInfo()
      console.log('2', ipinfo2)
      */
    } catch (e) {
      console.log("errr e", e);
    }
  };

  const getChange = () => {
    if (change === true && form.login !== "" && form.password !== "")
      return "contained";
    else return "outlined";
  };

  const handleSubmit = (auth) => {
    setLoading(true);
    /*
    login(
      auth,
      location.state ? (location.state as any).nextPathname : '/'
    ).catch((error: Error) => {
      setLoading(false)
      notify(
        typeof error === 'string'
          ? error
          : typeof error === 'undefined' || !error.message
          ? 'ra.auth.sign_in_error'
          : error.message,
        {
          type: 'warning',
          messageArgs: {
            _:
              typeof error === 'string'
                ? error
                : error && error.message
                ? error.message
                : undefined,
          },
        }
      )
    })
    */
  };
  //  const image = require(`assets/wt2.png`)
  //const image = Image('anna/wt1.png')
  // assets/wt2.png`
  //      <img src={image}></img>

  columns2 = [
    {
      id: 1,
      field: "num",
      label: "№",
      width: "60px",
    },
    {
      id: 2,
      field: "name",
      label: "Назва", //translate("resources.reference.fields.name"), //'Имя',
      width: "180px",
    },
    {
      id: 4,
      field: "adress",
      width: "60%",
      label: translate("resources.reference.fields.address"),
    },
    {
      id: "my-buttons-column",
      width: "max-content",
      pinned: true,
      sortable: false,
      resizable: false,
      cellRenderer: ({
        tableManager,
        value,
        data,
        column,
        colIndex,
        rowIndex,
      }) => (
        <button
          style={{ marginLeft: 20 }}
          onClick={(e) => {
            //tableManager.rowEditApi.setEditRowId(data.id);
            setOpenAddressDialog(true);
            setaddr = data;
            dispatch({
              type: "fetch/get_add", //'fetch/get_add',
              payload: data,
              ob: "setaddr",
            });
            settype2({
              label: setaddr.storetypename,
              value: setaddr.storetypeid,
            });
            //setValue("client", client);
            //setstartRefreshChats(true);
            //setstartRefreshTermins(true);
            //setOpenSearch(false);
            //setCustomer2({
            //  label: client.name + " " + client.surname,
            //  value: client.id,
            //});
          }}
          type="button"
        >
          &#x270E;
        </button>
      ),
    },
  ];
  let ii = 0;
  rows =
    customer &&
    customer.items &&
    customer.items.map(({ store }) => {
      //console.log("store", store);
      ii++;
      return {
        id: store && store.id,
        name: store && store.name,
        telefone: store && store.telefone,
        ind: store && store.ind,
        region: store && store.region,
        city: store && store.city,
        street: store && store.street,
        housenumber: store && store.housenumber,
        korpus: store && store.korpus,
        storetypeid: store && store.storetypeid,
        storetypename: store && store.storetype && store.storetype.name,
        apartmentnumber: store && store.apartmentnumber,

        num: ii,
        adress:
          store &&
          store.ind +
            ", " +
            store.region +
            ", " +
            store.city +
            ", " +
            store.street +
            ", д. " +
            store.housenumber +
            ",  " +
            store.apartmentnumber +
            ",  тел.: " +
            (store.telefone || ""),
      };
    });

  const getInfoDia = (deeplinks) => {
    let filename;
    let deeplink;
    let date;
    let id;
    let status;
    let item;
    if (deeplinks) {
      for (let i in deeplinks) {
        if (deeplinks[i].status !== "blocked") {
          item = deeplinks[i];
          id = item?.id;
          filename = item?.fileName;
          deeplink = item?.deeplink;
          status = item?.status;
          date = item?.date;
        }
      }
    }
    return { id, filename, deeplink, status, date };
  };

  docs =
    customer &&
    customer.documents &&
    customer.documents.map((item) => {
      //console.log("store", store);
      ii++;
      let { deeplink, id, status, date } = getInfoDia(item.deeplinks);
      return {
        id: item.id,
        name: item.name,
        pdflink: item.pdflink,
        filename: item.fileName, //item && item.fileName,
        filehash: item.fileHash, //item && item.fileHash,
        date: date,
        deeplink: deeplink, // item && item.deeplinks,
        deeplinks: item.deeplinks, // item && item.deeplinks,
        deeplinkid: id,
        deeplinkstatus: status,

        num: ii,
      };
    });

  const handle_GetDocument = async (params) => {
    let { document } = params;
    //
    //

    setdoc = document;
    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: document,
      ob: "setdoc",
    });

    setOpenDocumentsDialog(true);
  };
  const getDocument = async (data) => {
    try {
      const config = auth.config;

      let reference =
        location.pathname.split("/")[1] || auth.Customer.reference;
      //      let URLAPI = getURLAPI(config)
      let Options = {
        reference,
        customer,
        id: data.id,
        handle_GetData: handle_GetDocument,
        handle_ErrData: null,
        tableName: "ChangeCustomers",
      };
      //
      //if (customer) customer.ischanged = true;

      let URL_WS = getURLAPI(config, "URL_WS"); //get address WebSocket BK from config

      const data1 = await wssrequestget(Options, URL_WS, "getdocument");
    } catch (e) {
      console.log("errr e", e);
    }
  };

  columns3 = [
    {
      id: 1,
      field: "num",
      label: "№",
      width: "60px",
    },
    {
      id: 2,
      field: "name",
      label: "Назва документа", //translate("resources.reference.fields.name"), //'Имя',
      width: "max-content", //"280px",
    },
    {
      id: 3,
      field: "filename",
      label: "Имя файла", //translate("resources.reference.fields.name"), //'Имя',
      width: "max-content", //"280px",
    },
    {
      id: 4,
      field: "deeplink",
      label: "status", //translate("resources.reference.fields.name"), //'Имя',
      width: "max-content",
      pinned: true,
      sortable: false,
      resizable: false,
      cellRenderer: ({
        tableManager,
        value,
        data,
        column,
        colIndex,
        rowIndex,
      }) => {
        let status = data?.deeplinkstatus || "Not initialized";
        /*
        Status:
        1) initialized - готово к подписи  (Нельзя создавать новую подпись)
        2) processing - в процессе подписи (Нельзя создавать новую подпись)
        3) done  - подписан  - FINISH  (Нельзя создавать новую подпись)
        4) Refuse - не подписал   (МОЖНО создавать новую подпись)
        5) notUsed  - не успел подписать (МОЖНО создавать новую подпись)
        */
        return (
          <button
            style={{ marginLeft: 20 }}
            onClick={(e) => {
              //tableManager.rowEditApi.setEditRowId(data.id);
              //setValue("client", client);
              //setstartRefreshChats(true);
              //setstartRefreshTermins(true);
              //setOpenSearch(false);
              //setCustomer2({
              //  label: client.name + " " + client.surname,
              //  value: client.id,
              //});
            }}
            type="button"
          >
            {status}
          </button>
        );
      },
    },

    {
      id: "my-buttons-column",
      width: "max-content",
      pinned: true,
      sortable: false,
      resizable: false,
      cellRenderer: ({
        tableManager,
        value,
        data,
        column,
        colIndex,
        rowIndex,
      }) => {
        return (
          <button
            style={{ marginLeft: 20 }}
            onClick={async (e) => {
              //tableManager.rowEditApi.setEditRowId(data.id);
              getDocument(data);

              //setValue("client", client);
              //setstartRefreshChats(true);
              //setstartRefreshTermins(true);
              //setOpenSearch(false);
              //setCustomer2({
              //  label: client.name + " " + client.surname,
              //  value: client.id,
              //});
            }}
            type="button"
          >
            &#x270E;
          </button>
        );
      },
    },
  ];

  const [type2, settype2] = useState(null); //[])

  const changetype = (event, newValue) => {
    setChanged3(true);
    settype2(newValue);
    setaddr.storetypeid = newValue.value;
    setaddr.storetype = { name: newValue.label };
    saveAddr();
  };

  const saveAddr = () => {
    let items = customer.items;
    for (let i in items) {
      if (items[i].store.id === setaddr.id) {
        items[i].store = setaddr;
      }
    }
    customer.items = items;
    dispatch({
      type: "fetch/get_add", //'fetch/get_add',
      payload: customer,
      ob: "customer",
    });
  };

  const addNewAddr = () => {
    let items = customer.items;
    if (!setaddr.id) {
      items.push({ store: setaddr });

      customer.items = items;
      dispatch({
        type: "fetch/get_add", //'fetch/get_add',
        payload: customer,
        ob: "customer",
      });
    }
  };

  //*************************** */

  const addresshandleSave = async () => {
    setChanged1(false);
    setChanged2(false);
    setChanged3(false);
    //save in DB customer
    await saveHandler();
    setOpenAddressDialog(false);
  };

  const addresshandleAlertClose = async () => {
    //read from DB customer
    setChanged1(false);
    setChanged2(false);
    setChanged3(false);
    await loadHandler();
    setOpenAddressDialog(false);
  };

  const ready = () => {
    if (customer)
      // || !(worker2 && worker2.value))
      return true;
    else return false;
  };

  function MyQRCodeComponent({ qrCodeValue }) {
    return (
      <div style={{ background: "white", padding: "16px" }}>
        <a href={qrCodeValue} target="_blank" rel="noreferrer noopener">
          <QRCode value={qrCodeValue} size={128} />
        </a>
      </div>
    );
  }

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const [openSignDialog, setOpenSignDialog] = React.useState(false);

  const handleSignClose = () => {
    setOpenSignDialog(false);
    resetTimer();
  };
  const setMinutes = (m) => {
    Minutes = m;
    $("#Minutes").html(String(Minutes).padStart(2, "0"));
  };

  const setSeconds = (s) => {
    Seconds = s;
    $("#Seconds").html(String(Seconds).padStart(2, "0"));
  };

  useEffect(() => {
    setMinutes(StartMinutes);
    setSeconds(StartSeconds);
  }, []);

  //const [Minutes, setMinutes] = useState(3);
  //const [Seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  // Format Minutes and Seconds for display, ensuring two digits
  const formattedMinutes = String(Minutes).padStart(2, "0");
  const formattedSeconds = String(Seconds).padStart(2, "0");

  useEffect(() => {
    let interval;
    if (isRunning) {
      interval = setInterval(() => {
        if (Seconds === 0) {
          if (Minutes === 0) {
            clearInterval(interval);
            setIsRunning(false); // Timer finished
          } else {
            setMinutes(Minutes - 1); //(prevMinutes) => prevMinutes - 1);
            setSeconds(59);
          }
        } else {
          setSeconds(Seconds - 1); //(prevSeconds) => prevSeconds - 1);
        }
      }, 1000); // Update every second
    }
    return () => clearInterval(interval); // Cleanup on unmount or when isRunning changes
  }, [isRunning, Minutes, Seconds]);

  const startTimer = () => setIsRunning(true);
  const pauseTimer = () => setIsRunning(false);
  const resetTimer = () => {
    setIsRunning(false);
    setMinutes(StartMinutes);
    setSeconds(StartSeconds);
  };

  const isExits = () => {
    let rez = false;
    if (Minutes <= 0 && Seconds <= 0) {
      rez = true;
    }
    return rez;
  };

  function Sign(props) {
    return (
      <>
        <div
          style={{
            //            marginTop: -20,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            id="outlined-basic"
            label="Договор"
            //variant="standard"
            className="title h6"
            style={{
              //marginTop: 20,
              marginBottom: 0,
              marginRight: 40,
              marginLeft: 10,
              //display: 'flex',
              //justifyContent: 'space-between',
            }}
          >
            {
              "Підпис документа" /*translate("resources.reference.editcontract") + " :"*/
            }
          </Typography>
          {isExits() === true && (
            <Button
              sx={{
                ml: 1,
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "primary.light",
                  //backgroundColor: 'primary.dark',
                  opacity: [0.9, 0.8, 0.7],
                },
              }}
              variant="contained"
              onClick={handleSignClose}
            >
              {"X"}
            </Button>
          )}
        </div>
        <div
          style={{
            //            marginTop: -20,
            width: "100%",
            //display: "flex",
            justifyContent: "space-between",
          }}
        >
          <>
            <div
              style={{
                //margin: "0 auto",
                marginLeft: 10,
                //width: 400,
                //display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  //margin: "0 auto",
                  //width: 400,
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    //margin: "0 auto",
                    //width: 400,
                    display: "flex",
                    //justifyContent: "space-between",
                    flexWrap: "wrap",
                    flexDirection: "column",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    label={"Назва документа"} //"Тип работ"
                    //variant="standard"
                    variant="outlined"
                    style={{
                      //width: "100%",
                      width: 280,
                      marginBottom: 10,
                      marginRight: 10,
                    }}
                    value={(setdoc && setdoc.name) || ""}
                    /*
                                      onChange={(event) => {
                                        setChanged3(true);
                                        setaddr.region = event.target.value;
                                        dispatch({
                                          type: "fetch/get_add", //'fetch/get_add',
                                          payload: setdoc,
                                          ob: "setdoc",
                                        });
                                      }}*/
                  ></TextField>
                  <TextField
                    id="outlined-basic"
                    label={"Назва файла"} //"Тип работ"
                    //variant="standard"
                    variant="outlined"
                    style={{
                      //width: "100%",
                      width: 280,
                      marginBottom: 10,
                      marginRight: 10,
                    }}
                    value={(setdoc && setdoc.fileName) || ""}
                  ></TextField>
                </div>
                <div
                  style={{
                    //width: "100%",
                    width: 300,
                    marginTop: -20, //-40,
                    marginBottom: 10,
                    marginRight: 10,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {!isExits() === true && (
                    <MyQRCodeComponent qrCodeValue={setdoc?.deeplink || ""} />
                  )}
                  {isExits() === true && (
                    <Box
                      style={{
                        width: 128,
                        height: 128,
                        background: "white",
                        margin: "16px",
                      }}
                    ></Box>
                  )}
                </div>
                <div
                  style={{
                    //width: "100%",
                    width: 300,
                    marginTop: -14, //-40,
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    flexDirection: "column",
                  }}
                >
                  {
                    /*
                    <h3>
                      Timer: {formattedMinutes}:{formattedSeconds}
                    </h3>
                    */
                    <>
                      <h3>
                        Timer &nbsp;-&nbsp;
                        <span id="Minutes">&nbsp;03</span>:
                        <span id="Seconds">&nbsp;00</span>
                      </h3>
                    </>
                  }
                  {isExits() === true && (
                    <>
                      {" "}
                      <div>{"Час вийшов"}</div>
                      <div>{"(спробуйте ще раз)"}</div>
                    </>
                  )}
                  {!isExits() === true && (
                    <>
                      {" "}
                      <div>{"Проскануйте QRCOD"}</div>
                      <div>{"для підпису в Діі"}</div>
                    </>
                  )}
                </div>
              </div>
              <div style={{ height: "800px", padding: 5 }}>
                <ViewPdf filename={setdoc.pdflink} />
              </div>
            </div>
          </>
        </div>
      </>
    );
  }

  function SignDialog(props) {
    return (
      <>
        {/* Order Dialog */}
        <Dialog
          open={openSignDialog}
          maxWidth={"xl"}
          PaperComponent={isXSmall ? null : PaperComponent}
          aria-labelledby="draggable-dialog-title"
          onClose={handleSignClose}
          PaperProps={{
            component: "form",
            /*       onSubmit: async (event) => {
              event.preventDefault();
              //const formData = new FormData(event.currentTarget);
              //const formJson = Object.fromEntries(formData.entries());
            },*/
          }}
        >
          <DialogTitle
            style={{
              fontSize: "1.10rem",
            }}
          >
            <Sign />
          </DialogTitle>
          <DialogContent>
            {/*            <DialogContentText></DialogContentText> */}
          </DialogContent>
          {/*    <DialogActions></DialogActions>  */}
        </Dialog>
      </>
    );
  }

  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess(numPages) {
    setNumPages(numPages);
  }

  const ViewPdf = (props) => {
    let { filename } = props;
    let pdfUrl = filename;
    return (
      <iframe src={pdfUrl} width="100%" height="100%" title="PDF Viewer" />
    );
  };

  /*
  const ViewPdf1 = (props) => {
    let { filename, ...other } = props;

    //filename = "./contract123456.pdf";
    //    import samplePDF from './test.pdf';

    return (
      <div>
        <div>{filename}</div>
        <Document
          file={{ url: filename }}
          onLoadSuccess={onDocumentLoadSuccess}
          options={options}
        >
          <Page pageNumber={pageNumber} />
        </Document>
        <p>
          Page {pageNumber} of {numPages}
        </p>
      </div>
    );
  };
*/

  const getDeeplinkHandler = async () => {};

  const handle_GetDeepLink = async (params) => {
    console.log("params", params);
    let { deeplink, document } = params;

    setdoc = document;
    setdoc.deeplink = deeplink?.deeplink;
    //setdoc=......

    setOpenSignDialog(true);
    startTimer();
  };

  const isSigned = async () => {
    if (setdoc.deeplinkstatus === "signed") return true;
    else return false;
  };

  const getDeepLink = async (setdoc) => {
    let params = {
      id: setdoc.deeplinkid,
      documentid: setdoc.id, //"3",
      pdflink: setdoc.pdflink, //"....",
      fileName: setdoc.fileName,
      fileHash: setdoc.fileHash, // "MTIzNDU2Nzg5MDEyMzQ1Njc4OTAxMjM0NTY3ODkwMTI=",
    };

    let { documentid, pdflink, fileName, fileHash } = params;

    let val = {
      values: {
        id: setdoc.deeplinkid,
        documentid: setdoc.id, //"3",
        pdflink: setdoc.pdflink, //"....",
        fileName: setdoc.fileName,
        fileHash: setdoc.fileHash, // "MTIzNDU2Nzg5MDEyMzQ1Njc4OTAxMjM0NTY3ODkwMTI=",
      },
      tableName: "DeepLinks",
      where: {},
      action: {
        metod: "set",
      },
      auth: {
        userId: "38ad21bd-13bb-4966-85d7-433c550b2f9d",
        tocken:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIzOGFkMjFiZC0xM2JiLTQ5NjYtODVkNy00MzNjNTUwYjJmOWQiLCJpYXQiOjE2OTM1MjU1ODQsImV4cCI6MTY5NDEzMDM4NH0.8L1yPF7eyaKe91CWciJFxb2H68OK9kpPS7phKfxYB2g",
      },
    };
    console.log("value", val);
    try {
      const config = auth.config;

      let reference =
        location.pathname.split("/")[1] || auth.Customer.reference;
      //      let URLAPI = getURLAPI(config)
      let Options = {
        reference,
        customer,
        setdoc,
        handle_GetData: handle_GetDeepLink,
        handle_ErrData: null,
        tableName: "ChangeCustomers",
      };
      //
      if (customer) customer.ischanged = true;

      let URL_WS = getURLAPI(config, "URL_WS"); //get address WebSocket BK from config

      const data1 = await wssrequestget(Options, URL_WS, "getdeeplink");
    } catch (e) {
      console.log("errr e", e);
    }
  };

  const MidleComponents = () => {
    const classNames = "rgt-middle ".trim();

    return (
      <>
        <div style={{ marginLeft: 0 }} className={classNames}>
          <Button
            //variant={getChange()} //"outline-success"
            //type="submit"
            color="primary"
            sx={{
              ml: 1,
              alignItems: "center",
              "&:hover": {
                backgroundColor: "primary.light",
                //backgroundColor: 'primary.dark',
                opacity: [0.9, 0.8, 0.7],
              },
            }}
            variant="contained"
            style={{
              borderRadius: 10,
              //marginLeft: 15,
              //marginRight: 15,
            }}
            disabled={loading}
            fullWidth
            //onClick={logoutinHandler}
            onClick={(e) => {
              setOpenAddressDialog(true);

              let data = {};
              let testdata = {
                //id: "1-1-1-1",
                name: "Сагайдачного",
                telefone: "0500322234",
                ind: "022222",
                region: "Киевcкая обл",
                city: "Киев",
                street: "ул. Сагайдачного",
                housenumber: "11",
                korpus: "",
                storetypeid: "11-11-11",
                storetypename: "New",
                apartmentnumber: "12",
                num: 1,
                adress:
                  "022222, Киевcкая обл, Киев, ул. Сагайдачного, д. 11,  12",
              };
              setaddr = data;
              dispatch({
                type: "fetch/get_add", //'fetch/get_add',
                payload: data,
                ob: "setaddr",
              });
              settype2(types[0]);
              //addresshandleAlertClose();
            }}
          >
            {loading && <CircularProgress size={25} thickness={2} />}
            {"Додати адресу"}
          </Button>
        </div>
      </>
    );
  };

  const hh = (
    <>
      {ready() && (
        <>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            {!openSignDialog && (
              <Box
                sx={{
                  width: !isXSmall ? "80%" : "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  // marginTop: 1,
                  //marginBottom: -10,
                  //paddingBottom: -10,
                  justifyContent: "space-between",
                }}
              >
                <>
                  <div
                    style={{
                      //margin: "0 auto",
                      width: "99%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      //variant={getChange()} //"outline-success"
                      //type="submit"
                      color="primary"
                      sx={{
                        ml: 1,
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "primary.light",
                          //backgroundColor: 'primary.dark',
                          opacity: [0.9, 0.8, 0.7],
                        },
                      }}
                      variant="contained"
                      style={{
                        borderRadius: 10,
                        //marginLeft: 15,
                        //marginRight: 15,
                      }}
                      disabled={loading}
                      fullWidth
                      onClick={logoutinHandler}
                    >
                      {loading && <CircularProgress size={25} thickness={2} />}
                      {"Закрити"}
                    </Button>
                    <Button
                      //variant={getChange()} //"outline-success"
                      type="submit"
                      color="primary"
                      sx={{
                        ml: 1,
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "primary.light",
                          //backgroundColor: 'primary.dark',
                          opacity: [0.9, 0.8, 0.7],
                        },
                      }}
                      variant="contained"
                      style={{
                        //marginLeft: 15,
                        borderRadius: 10,
                        //marginRight: 15,
                      }}
                      disabled={customer && !customer.ischanged}
                      fullWidth
                      onClick={logoutinHandler}
                    >
                      {loading && <CircularProgress size={25} thickness={2} />}
                      {"Надіслати"}
                    </Button>
                  </div>
                  <TabContext value={tab} sx={{ p: 0 }}>
                    <Box
                      sx={{
                        borderBottom: 0,
                        borderColor: "divider",
                        p: 0,
                        width: { sm: !isXSmall ? "100%" : "100%", xs: "100%" },
                        m: 2,
                      }}
                    >
                      <TabList
                        onChange={(_, value) => {
                          //OnChangeTab1(value);
                          setTab(value);
                        }}
                        aria-label="API tabs"
                        variant="scrollable"
                      >
                        <Tab
                          label={"Основна інформація"} //{translate("resources.reference.main")}
                          value="1"
                        />
                        <Tab
                          label={"Адреса підприємства"} //translate("resources.reference.mainaddress")}
                          style={
                            (customer && customer.length) > 0
                              ? { color: "green", fontWeight: "bold" }
                              : {}
                          }
                          value="2"
                        />
                        <Tab
                          label={"Адреси доставки"} //translate("resources.reference.address")}
                          style={
                            (customer && customer.length) > 0
                              ? { color: "green", fontWeight: "bold" }
                              : {}
                          }
                          value="3"
                        />
                        <Tab
                          label={"Документи"} //translate("resources.reference.documents")}
                          style={
                            (customer && customer.length) > 0
                              ? { color: "green", fontWeight: "bold" }
                              : {}
                          }
                          value="4"
                        />
                      </TabList>
                      <TabPanel value="1" sx={{ p: 0 }}>
                        <Card
                          sx={{
                            minWidth: 255,
                            marginBottom: 1,
                            marginRight: 1,
                            borderRadius: 3, //height: 760,
                          }}
                        >
                          <CardContent style={{ padding: "12px 18px 8px 4px" }}>
                            <div
                              style={{
                                //margin: "0 auto",
                                //width: 400,
                                //display: "flex",
                                padding: 4,
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <TextField
                                  id="outlined-basic1"
                                  label={"Найменування"} //"Тип работ"
                                  //variant="standard"
                                  variant="outlined"
                                  //sx={{ borderRadius: 10 }}
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.name) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.name = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>{" "}
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <TextField
                                  id="outlined-basic2"
                                  label={"Повне найменування"} //"Тип работ"
                                  //variant="standard"
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.fullname) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.fullname = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <TextField
                                  id="outlined-basic"
                                  label={"ИНН"} //"Тип работ"
                                  //variant="standard"
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.inn) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.inn = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic3"
                                  label={"ЕГРПОУ"} //"Тип работ"
                                  //variant="standard"
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.egrpou) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.egrpou = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic6"
                                  label={"IBAN"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.iban) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.iban = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>

                                <TextField
                                  id="outlined-basic5"
                                  label={"Телефон"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.telefone) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.telefone = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic4"
                                  label={"email"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.email) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.email = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>
                              <Divider
                                style={{ marginTop: 2, marginBottom: 2 }}
                              >
                                Відповідальні особи
                              </Divider>
                              {/* ДИР */}{" "}
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    width: 340,
                                    marginLeft: 10,
                                    marginTop: 10,
                                    marginRight: 10,
                                  }}
                                >
                                  Директор
                                </div>
                                <TextField
                                  id="outlined-basic8"
                                  label={"ПІБ"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.directorfio) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.directorfio = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic8"
                                  label={"тел"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.directortel) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.directortel = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>

                                <TextField
                                  id="outlined-basic8"
                                  label={"email"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.directoremail) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.directoremail = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>
                              {/* Bug */}
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    width: 340,
                                    marginLeft: 10,
                                    marginTop: 10,
                                    marginRight: 10,
                                  }}
                                >
                                  Бухгалтер
                                </div>
                                <TextField
                                  id="outlined-basic8"
                                  label={"ПІБ"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.buhgfio) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.buhgfio = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic8"
                                  label={"тел"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.buhgtel) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.buhgtel = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>

                                <TextField
                                  id="outlined-basic8"
                                  label={"email"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.buhgemail) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.buhgemail = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>
                              {/* Закупка */}
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    width: 340,
                                    marginLeft: 10,
                                    marginTop: 10,
                                    marginRight: 10,
                                  }}
                                >
                                  Закупник
                                </div>
                                <TextField
                                  id="outlined-basic8"
                                  label={"ПІБ"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.buyerfio) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.buyerfio = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic8"
                                  label={"тел"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={(customer && customer.buyertel) || ""}
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.buyertel = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>

                                <TextField
                                  id="outlined-basic8"
                                  label={"email"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.buyeremail) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.buyeremail = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>
                              {/* Приемка */}
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    width: 340,
                                    marginLeft: 10,
                                    marginTop: 10,
                                    marginRight: 10,
                                  }}
                                >
                                  Приймальник
                                </div>
                                <TextField
                                  id="outlined-basic8"
                                  label={"ПІБ"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.receiverfio) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.receiverfio = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                                <TextField
                                  id="outlined-basic8"
                                  label={"тел"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.receivertel) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.receivertel = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>

                                <TextField
                                  id="outlined-basic8"
                                  label={"email"}
                                  variant="outlined"
                                  style={{
                                    width: "100%",
                                    //marginBottom: 10,
                                    marginRight: 10,
                                  }}
                                  value={
                                    (customer && customer.receiveremail) || ""
                                  }
                                  onChange={(event) => {
                                    setChanged1(true);
                                    customer.receiveremail = event.target.value;
                                    dispatch({
                                      type: "fetch/get_add", //'fetch/get_add',
                                      payload: customer,
                                      ob: "customer",
                                    });
                                  }}
                                ></TextField>
                              </div>
                              {/* end */}
                              <Button
                                style={{ borderRadius: 10 }}
                                sx={{
                                  ml: 1,
                                  alignItems: "center",
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    //backgroundColor: 'primary.dark',
                                    opacity: [0.9, 0.8, 0.7],
                                  },
                                }}
                                disabled={!changed1}
                                variant="contained"
                                onClick={(e) => {
                                  addresshandleAlertClose();
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                style={{ borderRadius: 10 }}
                                sx={{
                                  ml: 1,
                                  alignItems: "center",
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    //backgroundColor: 'primary.dark',
                                    opacity: [0.9, 0.8, 0.7],
                                  },
                                }}
                                variant="contained"
                                disabled={!changed1}
                                //type="submit"
                                onClick={(e) => {
                                  addresshandleSave();
                                }}
                              >
                                Save
                              </Button>
                            </div>
                          </CardContent>
                        </Card>
                      </TabPanel>
                      <TabPanel value="2" sx={{ p: 0 }}>
                        <Card
                          sx={{
                            minWidth: 255,
                            //marginBottom: 1,
                            borderRadius: 3,
                            marginRight: 1,
                            //height: 760,
                          }}
                        >
                          <CardContent style={{ padding: "12px 18px 8px 4px" }}>
                            <div
                              style={{
                                //margin: "0 auto",
                                //width: 400,
                                //display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //marginRight: 40,
                                  //width: 400,
                                  //display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    id="outlined-basic"
                                    label="Клиент"
                                    //variant="standard"
                                    className="title h6"
                                    style={{
                                      //marginTop: 20,
                                      marginBottom: 10,
                                      marginRight: 40,
                                      //display: 'flex',
                                      //justifyContent: 'space-between',
                                    }}
                                  >
                                    {
                                      "Юридична адреса :" /*translate("resources.reference.uraddr") + " :"*/
                                    }
                                  </Typography>
                                </div>
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <TextField
                                    id="outlined-basic"
                                    label={"Область"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.uradr_region) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_region =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Місто"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.uradr_city) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_city = event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Індекс"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      //width: 200,
                                      marginBottom: 10,
                                      borderRadius: "10px",
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.uradr_ind) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_ind = event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                </div>
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <TextField
                                    id="outlined-basic"
                                    label={"Вулиця"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.uradr_street) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_street =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Номер будинку"}
                                    variant="outlined"
                                    style={{
                                      width: 200,
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer &&
                                        customer.uradr_housenumber) ||
                                      ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_housenumber =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Корпус"}
                                    variant="outlined"
                                    style={{
                                      width: 200,
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.uradr_korpus) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_korpus =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Номер кв"}
                                    variant="outlined"
                                    style={{
                                      width: 200,
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer &&
                                        customer.uradr_apartmentnumber) ||
                                      ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.uradr_apartmentnumber =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  marginTop: 10,
                                  marginBottom: 10,
                                }}
                              />
                              <div
                                style={{
                                  //margin: "0 auto",
                                  //width: 400,
                                  //display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    id="outlined-basic"
                                    label="Клиент"
                                    //variant="standard"
                                    className="title h6"
                                    style={{
                                      //marginTop: 20,
                                      marginBottom: 10,
                                      marginRight: 40,
                                      //width: 200,
                                      //display: 'flex',
                                      //justifyContent: 'space-between',
                                    }}
                                  >
                                    {
                                      "Фізична адреса" /*translate("resources.reference.fizaddr")*/
                                    }
                                  </Typography>
                                </div>
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <TextField
                                    id="outlined-basic"
                                    label={"Область"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.fizadr_region) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.fizadr_region =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Місто"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.fizadr_city) || ""
                                    }
                                    onChange={(event) => {
                                      customer.fizadr_city = event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Індекс"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      //width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.fizadr_ind) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.fizadr_ind = event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                </div>
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <TextField
                                    id="outlined-basic"
                                    label={"Вулиця"} //"Тип работ"
                                    //variant="standard"
                                    variant="outlined"
                                    style={{
                                      width: "100%",
                                      marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.fizadr_street) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.fizadr_street =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Номер будинку"}
                                    variant="outlined"
                                    style={{
                                      width: 200,
                                      //marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer &&
                                        customer.fizadr_housenumber) ||
                                      ""
                                    }
                                    onChange={(event) => {
                                      customer.fizadr_housenumber =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Корпус"}
                                    variant="outlined"
                                    style={{
                                      width: 200,
                                      //marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer && customer.fizadr_korpus) || ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.fizadr_korpus =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                  <TextField
                                    id="outlined-basic"
                                    label={"Номер кв"}
                                    variant="outlined"
                                    style={{
                                      width: 200,
                                      //marginBottom: 10,
                                      marginRight: 10,
                                    }}
                                    value={
                                      (customer &&
                                        customer.fizadr_apartmentnumber) ||
                                      ""
                                    }
                                    onChange={(event) => {
                                      setChanged2(true);
                                      customer.fizadr_apartmentnumber =
                                        event.target.value;
                                      dispatch({
                                        type: "fetch/get_add", //'fetch/get_add',
                                        payload: customer,
                                        ob: "customer",
                                      });
                                    }}
                                  ></TextField>
                                </div>
                              </div>
                              <Button
                                style={{ borderRadius: 10 }}
                                sx={{
                                  ml: 1,
                                  alignItems: "center",
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    //backgroundColor: 'primary.dark',
                                    opacity: [0.9, 0.8, 0.7],
                                  },
                                }}
                                variant="contained"
                                disabled={!changed2}
                                onClick={(e) => {
                                  addresshandleAlertClose();
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                style={{ borderRadius: 10 }}
                                sx={{
                                  ml: 1,
                                  alignItems: "center",
                                  "&:hover": {
                                    backgroundColor: "primary.light",
                                    //backgroundColor: 'primary.dark',
                                    opacity: [0.9, 0.8, 0.7],
                                  },
                                }}
                                disabled={!changed2}
                                variant="contained"
                                //type="submit"
                                onClick={(e) => {
                                  addresshandleSave();
                                }}
                              >
                                Save
                              </Button>
                            </div>
                          </CardContent>
                        </Card>
                      </TabPanel>
                      <TabPanel value="3" sx={{ p: 0 }}>
                        <Card
                          sx={{
                            minWidth: 255,
                            //marginBottom: 1,
                            borderRadius: 3, //height: 760,
                            marginRight: 1,
                          }}
                        >
                          <CardContent style={{ padding: "12px 18px 8px 4px" }}>
                            <div
                              style={{
                                //margin: "0 auto",
                                width: "100%",
                                //display: "flex",
                                //justifyContent: "space-between",
                              }}
                            >
                              {!openAddressDialog && (
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    //display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <GridTable
                                    //enableColumnsReorder={false}
                                    //isPageSize={false}
                                    showSearch={false}
                                    showRowsInformation={false}
                                    components={{ MidleComponents }}
                                    tableHasSelection={true}
                                    showColumnVisibilityManager={false}
                                    columns={columns2}
                                    pageSizes={[5, 10]}
                                    rows={rows}
                                  />
                                </div>
                              )}
                              {openAddressDialog && (
                                <>
                                  <div
                                    style={{
                                      //margin: "0 auto",
                                      //width: 400,
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography
                                      id="outlined-basic"
                                      label="Клиент"
                                      //variant="standard"
                                      className="title h6"
                                      style={{
                                        //marginTop: 20,
                                        marginBottom: 20,
                                        marginRight: 40,
                                        //display: 'flex',
                                        //justifyContent: 'space-between',
                                      }}
                                    >
                                      {
                                        "Редагування адреси :" /*translate("resources.reference.editaddr") +" :"*/
                                      }
                                    </Typography>
                                  </div>
                                  <div
                                    style={{
                                      //margin: "0 auto",
                                      marginBottom: 20,
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <TextField
                                      id="outlined-basic"
                                      label={"Назва "} //"Тип работ"
                                      //variant="standard"
                                      variant="outlined"
                                      style={{
                                        width: "100%",
                                        marginBottom: 10,
                                        marginRight: 10,
                                      }}
                                      value={(setaddr && setaddr.name) || ""}
                                      onChange={(event) => {
                                        setChanged3(true);
                                        setaddr.name = event.target.value;
                                        dispatch({
                                          type: "fetch/get_add", //'fetch/get_add',
                                          payload: setaddr,
                                          ob: "setaddr",
                                        });
                                      }}
                                    ></TextField>

                                    <Autocomplete
                                      //multiple
                                      id="size-small-outlined" //      id="checkboxes-tags"
                                      options={types}
                                      onChange={changetype}
                                      size="large" //                            "small"
                                      style={{
                                        width: "90%",
                                        fontSize: "xx-large",
                                      }}
                                      value={type2} //[...vid2]}
                                      //                defaultValue={(vid2 && vid2[0]) || []}
                                      limitTags={2}
                                      //              filterSelectedOptions
                                      isOptionEqualToValue={(props, option) => {
                                        let rez = false;
                                        if (props.value === option.value)
                                          rez = true;
                                        return rez;
                                      }}
                                      selectOnFocus
                                      clearOnBlur
                                      onFocus={(e) => {
                                        //            console.log(e.target.readOnly)
                                        return (e.target.readOnly = true);
                                      }} //выключение клавиатуры при выборе      handleHomeEndKeys
                                      //      disableCloseOnSelect
                                      getOptionLabel={(option) => option.label}
                                      renderOption={(
                                        props,
                                        option,
                                        { selected }
                                      ) => {
                                        return (
                                          <li
                                            {...props}
                                            style={{
                                              //width: "50%",
                                              fontSize: "x-large",
                                            }}
                                          >
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selected}
                                            />
                                            {option.label}
                                          </li>
                                        );
                                      }}
                                      //style={{ width: isXSmall ? 210 : 400 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          style={{
                                            fontSize: "xx-large",
                                          }}
                                          label={"Виберіть тип закладу"} //translate("resources.reference.changetypes")}
                                          //'Выберите рабочее место' : 'Выбери мастера'}
                                          variant="outlined"
                                          //          variant="standard"
                                          //          placeholder="Выберите Мастера"
                                        />
                                      )}
                                    />
                                    <Button
                                      style={{ borderRadius: 10 }}
                                      sx={{
                                        ml: 1,
                                        alignItems: "center",
                                        "&:hover": {
                                          backgroundColor: "primary.light",
                                          //backgroundColor: 'primary.dark',

                                          opacity: [0.9, 0.8, 0.7],
                                        },
                                      }}
                                      variant="contained"
                                      //disabled={!changed3}
                                      onClick={(e) => {
                                        setOpenAddressDialog(false);
                                      }}
                                      /*                                    onClick={(e) => {
                                      //tableManager.rowEditApi.setEditRowId(data.id);
                                      setOpenAddressDialog(false);
                                    }}*/
                                    >
                                      Help
                                    </Button>
                                  </div>
                                  <div
                                    style={{
                                      //margin: "0 auto",
                                      //marginRight: 40,
                                      //width: 400,
                                      //display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      style={{
                                        //margin: "0 auto",
                                        //width: 400,
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        label={"Область"} //"Тип работ"
                                        //variant="standard"
                                        variant="outlined"
                                        style={{
                                          width: "100%",
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={
                                          (setaddr && setaddr.region) || ""
                                        }
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.region = event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                      <TextField
                                        id="outlined-basic"
                                        label={"Місто"} //"Тип работ"
                                        //variant="standard"
                                        variant="outlined"
                                        style={{
                                          width: "100%",
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={(setaddr && setaddr.city) || ""}
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.city = event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                      <TextField
                                        id="outlined-basic"
                                        label={"Індекс"} //"Тип работ"
                                        //variant="standard"
                                        variant="outlined"
                                        style={{
                                          //width: 200,
                                          marginBottom: 10,
                                          borderRadius: "10px",
                                          marginRight: 10,
                                        }}
                                        value={(setaddr && setaddr.ind) || ""}
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.ind = event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                    </div>
                                    <div
                                      style={{
                                        //margin: "0 auto",
                                        //width: 400,
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <TextField
                                        id="outlined-basic"
                                        label={"Телефон"} //"Тип работ"
                                        //variant="standard"
                                        variant="outlined"
                                        style={{
                                          width: "100%",
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={
                                          (setaddr && setaddr.telefone) || ""
                                        }
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.telefone = event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>

                                      <TextField
                                        id="outlined-basic"
                                        label={"Вулиця"} //"Тип работ"
                                        //variant="standard"
                                        variant="outlined"
                                        style={{
                                          width: "100%",
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={
                                          (setaddr && setaddr.street) || ""
                                        }
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.street = event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                      <TextField
                                        id="outlined-basic"
                                        label={"Номер будинку"}
                                        variant="outlined"
                                        style={{
                                          width: 200,
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={
                                          (setaddr && setaddr.housenumber) || ""
                                        }
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.housenumber =
                                            event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                      <TextField
                                        id="outlined-basic"
                                        label={"Корпус"}
                                        variant="outlined"
                                        style={{
                                          width: 200,
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={
                                          (setaddr && setaddr.korpus) || ""
                                        }
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.korpus = event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                      <TextField
                                        id="outlined-basic"
                                        label={"Номер кв"}
                                        variant="outlined"
                                        style={{
                                          width: 200,
                                          marginBottom: 10,
                                          marginRight: 10,
                                        }}
                                        value={
                                          (setaddr &&
                                            setaddr.apartmentnumber) ||
                                          ""
                                        }
                                        onChange={(event) => {
                                          setChanged3(true);
                                          setaddr.apartmentnumber =
                                            event.target.value;
                                          dispatch({
                                            type: "fetch/get_add", //'fetch/get_add',
                                            payload: setaddr,
                                            ob: "setaddr",
                                          });
                                        }}
                                      ></TextField>
                                    </div>

                                    <Button
                                      style={{ borderRadius: 10 }}
                                      sx={{
                                        ml: 1,
                                        alignItems: "center",
                                        "&:hover": {
                                          backgroundColor: "primary.light",
                                          //backgroundColor: 'primary.dark',
                                          opacity: [0.9, 0.8, 0.7],
                                        },
                                      }}
                                      variant="contained"
                                      //disabled={!changed3}
                                      onClick={(e) => {
                                        setOpenAddressDialog(false);
                                      }}
                                      /*                                    onClick={(e) => {
                                      //tableManager.rowEditApi.setEditRowId(data.id);
                                      setOpenAddressDialog(false);
                                    }}*/
                                    >
                                      Return
                                    </Button>
                                    <Button
                                      style={{ borderRadius: 10 }}
                                      sx={{
                                        ml: 1,
                                        alignItems: "center",
                                        "&:hover": {
                                          backgroundColor: "primary.light",
                                          //backgroundColor: 'primary.dark',
                                          opacity: [0.9, 0.8, 0.7],
                                        },
                                      }}
                                      variant="contained"
                                      disabled={!changed3}
                                      type="submit"
                                      onClick={async (e) => {
                                        //tableManager.rowEditApi.setEditRowId(data.id);
                                        if (setaddr.id) {
                                          saveAddr();
                                          addresshandleSave();
                                        } else {
                                          await saveNewAddrHandler();
                                          setOpenAddressDialog(false);
                                        }
                                        setOpenAddressDialog(false);
                                      }}
                                    >
                                      Save
                                    </Button>
                                  </div>
                                </>
                              )}
                            </div>
                          </CardContent>
                        </Card>
                      </TabPanel>
                      {/* ***************************** */}
                      <TabPanel value="4" sx={{ p: 0 }}>
                        <Card
                          sx={{
                            minWidth: 255,
                            //marginBottom: 1,
                            borderRadius: 3, //height: 760,
                            marginRight: 1,
                          }}
                        >
                          <CardContent style={{ padding: "12px 18px 8px 4px" }}>
                            <div
                              style={{
                                //margin: "0 auto",
                                width: "100%",
                                //display: "flex",
                                //justifyContent: "space-between",
                              }}
                            >
                              {!openDocumentsDialog && (
                                <div
                                  style={{
                                    //margin: "0 auto",
                                    //width: 400,
                                    //display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <GridTable
                                    //enableColumnsReorder={false}
                                    //isPageSize={false}
                                    showSearch={false}
                                    showRowsInformation={false}
                                    tableHasSelection={true}
                                    showColumnVisibilityManager={false}
                                    columns={columns3}
                                    pageSizes={[5, 10]}
                                    rows={docs}
                                  />
                                </div>
                              )}
                              {openDocumentsDialog && (
                                <>
                                  <div
                                    style={{
                                      //margin: "0 auto",
                                      //width: 400,
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography
                                      id="outlined-basic"
                                      label="Договор"
                                      //variant="standard"
                                      className="title h6"
                                      style={{
                                        //marginTop: 20,
                                        marginBottom: 0,
                                        marginRight: 40,
                                        //display: 'flex',
                                        //justifyContent: 'space-between',
                                      }}
                                    >
                                      {
                                        isSigned()
                                          ? "Документ підписано!!!"
                                          : "Документ на підпис" /*translate("resources.reference.editcontract") + " :"*/
                                      }
                                    </Typography>
                                  </div>

                                  <div
                                    style={{
                                      //margin: "0 auto",
                                      //marginRight: 40,
                                      //width: 400,
                                      //display: "flex",
                                      justifyContent: "space-between",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <div
                                      style={{
                                        //margin: "0 auto",
                                        //width: 400,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <div>
                                        <TextField
                                          id="outlined-basic"
                                          label={"Назва документа"} //"Тип работ"
                                          //variant="standard"
                                          variant="outlined"
                                          style={{
                                            //width: "100%",
                                            width: 400,
                                            marginBottom: 10,
                                            marginRight: 10,
                                          }}
                                          value={(setdoc && setdoc.name) || ""}
                                          /*
                                      onChange={(event) => {
                                        setChanged3(true);
                                        setaddr.region = event.target.value;
                                        dispatch({
                                          type: "fetch/get_add", //'fetch/get_add',
                                          payload: setdoc,
                                          ob: "setdoc",
                                        });
                                      }}*/
                                        ></TextField>
                                        <TextField
                                          id="outlined-basic"
                                          label={"Назва файла"} //"Тип работ"
                                          //variant="standard"
                                          variant="outlined"
                                          style={{
                                            //width: "100%",
                                            width: 400,
                                            marginBottom: 10,
                                            marginRight: 10,
                                          }}
                                          value={
                                            (setdoc && setdoc.fileName) || ""
                                          }
                                          /*
                                      onChange={(event) => {
                                        setChanged3(true);
                                        setaddr.region = event.target.value;
                                        dispatch({
                                          type: "fetch/get_add", //'fetch/get_add',
                                          payload: setdoc,
                                          ob: "setdoc",
                                        });
                                      }}*/
                                        ></TextField>
                                        {/*
                                    <IconButton
                                      //sx={{ fontSize: 80 }}
                                      fontSize="large"
                                      style={
                                        {
                                          //right: "12px",
                                          //top: "8px",
                                          //position: "absolute",
                                        }
                                      }
                                      onClick={(e) => {
                                        //setOpenDocumentsDialog(false);
                                      }}
                                    >
                                      <PictureAsPdfIcon color="primary" />
                                    </IconButton>
                                    */}
                                      </div>
                                      <div></div>
                                      <Button
                                        style={{ borderRadius: 10 }}
                                        sx={{
                                          ml: 1,
                                          height: 38,
                                          alignItems: "center",
                                          "&:hover": {
                                            backgroundColor: "primary.light",
                                            //backgroundColor: 'primary.dark',
                                            opacity: [0.9, 0.8, 0.7],
                                          },
                                        }}
                                        variant="contained"
                                        //disabled={!changed3}
                                        onClick={(e) => {
                                          setOpenDocumentsDialog(false);
                                        }}
                                        /*                                    onClick={(e) => {
                                      //tableManager.rowEditApi.setEditRowId(data.id);
                                      setOpenDocumentsDialog(false);
                                    }}*/
                                      >
                                        Return
                                      </Button>
                                      <Button
                                        style={{ borderRadius: 10 }}
                                        sx={{
                                          ml: 1,
                                          height: 38,
                                          alignItems: "center",
                                          "&:hover": {
                                            backgroundColor: "primary.light",
                                            //backgroundColor: 'primary.dark',
                                            opacity: [0.9, 0.8, 0.7],
                                          },
                                        }}
                                        variant="contained"
                                        disabled={isSigned}
                                        onClick={async (e) => {
                                          if (!setdoc) return;
                                          await getDeepLink(setdoc);

                                          //resetTimer();
                                          //startTimer();
                                          //NiceModal.show(MyMuiDialog);
                                          //setOpenDocumentsDialog(false);
                                        }}
                                        /*                                    onClick={(e) => {
                                      //tableManager.rowEditApi.setEditRowId(data.id);
                                      setOpenDocumentsDialog(false);
                                    }}*/
                                      >
                                        Підписати
                                      </Button>
                                    </div>
                                    <div
                                      style={{ height: "800px", padding: 5 }}
                                    >
                                      <ViewPdf filename={setdoc.pdflink} />
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </CardContent>
                        </Card>
                        {/*
                    <SignDialog />
                    */}
                      </TabPanel>
                    </Box>
                  </TabContext>
                </>
              </Box>
            )}
            {openSignDialog && <Sign />}
          </LocalizationProvider>
          {/* Alert Dialog  <AddressDialog /> */}
        </>
      )}
      {!ready() && (
        <>
          <Box maxWidth="30em">
            <Card>
              <CardContent>
                <Spinner />
              </CardContent>
            </Card>
          </Box>
        </>
      )}
    </>
  );

  return hh;
};

GetClient.propTypes = {
  authProvider: PropTypes.func,
  previousRoute: PropTypes.string,
};

export default GetClient;
/*
interface FormValues {
  username?: string
  password?: string
}
*/
